import { render, staticRenderFns } from "./registry.vue?vue&type=template&id=1730d752&"
import script from "./registry.vue?vue&type=script&lang=js&"
export * from "./registry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports